import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import LinkIcon from '../../../../../utils/icons/linkIcon';
import MetamaskLogo from '../../../../../utils/icons/metamaskLogo';
import { SocialsGamePanel } from '../SocialsGame/socialsGame';
import { useFormik, useFormikContext } from 'formik';

export const TopPanelGame = ({
	name,
	nameActive,
	cover,
}: {
	name: string;
	nameActive: boolean | undefined;
	cover: string;
}) => {
	const { values } = useFormikContext();

	return (
		<>
			<Box
				pos="relative"
				zIndex="0"
				w="260px"
				h="145px"
			>
				<Box
					w="100%"
					h="100%"
					backgroundImage={cover}
					backgroundSize="cover"
					position="absolute"
					top="0"
					left="0"
					filter="blur(25px)"
					zIndex="0"
				/>
				<Box
					w="100%"
					h="100%"
					position="absolute"
					backgroundImage={cover}
					backgroundSize="cover"
					zIndex="2"
				/>
			</Box>
			<Flex
				direction="column"
				ml="27px"
				alignItems="start"
			>
				<Text
					fontSize="20px"
					fontWeight="600"
				>
					{name}

					{nameActive && (
						<Box
							display="inline"
							fontSize="25px"
						>
							▮
						</Box>
					)}
				</Text>
				<Flex
					alignItems="center"
					justifyContent="center"
					gridGap="8px"
				>
					<Text
						fontSize="13px"
						color="white"
					>
						0x17653...15753
					</Text>
					<LinkIcon />
				</Flex>
				<Flex
					gridGap="18px"
					alignItems="flex-start"
					pt="8px"
				>
					<Text
						fontSize="20px"
						fontWeight="600"
					>
						$43.12
					</Text>
					<Flex direction="column">
						<Text fontSize="8px">Start price</Text>
						<Text
							fontSize="10px"
							fontWeight="600"
						>
							$1.00
						</Text>
					</Flex>
					<Flex direction="column">
						<Text fontSize="8px">Total supply</Text>
						<Text
							fontSize="10px"
							fontWeight="600"
						>
							133,700
						</Text>
					</Flex>
					<Flex direction="column">
						<Text fontSize="8px">Market Cap</Text>
						<Text
							fontSize="10px"
							fontWeight="600"
						>
							Unknown
						</Text>
					</Flex>
					<Flex
						direction="column"
						gridGap="2px"
					>
						<Text fontSize="8px">Cartridge</Text>
						<Box
							fontSize="8px"
							fontWeight="600"
							borderRadius="3px"
							display="flex"
							bgColor="#BEA379"
							color="white"
							alignItems="center"
							justifyContent="center"
						>
							{' '}
							GOLD{' '}
						</Box>
					</Flex>
				</Flex>
				<Flex pt="4px">
					<Box
						display="flex"
						bgColor="white"
						borderRadius="2.5"
						alignItems="center"
						justifyContent="center"
						p="2px 4px"
						gridGap="2px"
					>
						<MetamaskLogo />
						<Text
							textTransform="uppercase"
							color="#676767"
							fontSize="6px"
						>
							add to wallet
						</Text>
					</Box>
				</Flex>
				<Flex pt="12px">
					<SocialsGamePanel
						socials={{}}
						web={(values as any).gameUrl}
					/>
				</Flex>
			</Flex>
		</>
	);
};

export default TopPanelGame;
